import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------ English ------------------------------ */
i18next.addResources(locales.EN, 'CONTACT', {
  TITLE: 'Contact Us',
  DESCRIPTION:
    'If you have any questions or need assistance, please reach out to us through the following contact methods.',
  WHATSAPP_LABEL: 'WhatsApp Number:',
  EMAIL_LABEL: 'Email Us',
  FORM_NAME: 'Name',
  FORM_EMAIL: 'Email',
  FORM_MESSAGE: 'Message',
  FORM_SUBMIT: 'Submit',
  FORM_SUCCESS: 'Your message has been sent successfully!',
  FORM_ERROR: 'There was an error sending your message. Please try again later.',
  SUBJECT: 'Subject',
  MESSAGE: 'Message',
  LOADING: 'Loading...',
});

/* ------------------------------ Spanish ------------------------------ */
i18next.addResources(locales.ES, 'CONTACT', {
  TITLE: 'Contáctenos',
  DESCRIPTION:
    'Si tiene alguna pregunta o necesita asistencia, por favor contáctenos a través de los siguientes métodos de contacto.',
  WHATSAPP_LABEL: 'Número de WhatsApp:',
  EMAIL_LABEL: 'Envíenos un correo electrónico',
  FORM_NAME: 'Nombre',
  FORM_EMAIL: 'Correo electrónico',
  FORM_MESSAGE: 'Mensaje',
  FORM_SUBMIT: 'Enviar',
  FORM_SUCCESS: '¡Su mensaje ha sido enviado con éxito!',
  FORM_ERROR: 'Hubo un error al enviar su mensaje. Por favor, inténtelo de nuevo más tarde.',
  SUBJECT: 'Asunto',
  MESSAGE: 'Mensaje',
  LOADING: 'Cargando...',
});
